import { useEffect } from "react"
import routes from "routes"

import { useSuraasaPlusNewYear } from "../Context"
import { ImpactCourseTourElementType, useTourContext } from "../TourProvider"

export const useImpactCourseTour = (props?: {
  isLoading?: boolean
  page: "course" | "learning"
  tourElementType?: ImpactCourseTourElementType
}) => {
  const context = useTourContext()
  const { spnyImpactCourseTour } = useSuraasaPlusNewYear()
  const isLearningRoute = location.pathname === routes.learning
  const isCourseRoute = location.pathname.includes("/course")

  if (!context) {
    throw new Error("useTour must be used within a ImpactCourseTourProvider")
  }

  const { setStep, step } = context

  const onComplete = () => {
    setStep(null)
  }

  useEffect(() => {
    if (!step) return
    if (step === "warning") return
    if (!isLearningRoute && !isCourseRoute) return
    if (props) {
      const { isLoading } = props

      if (isLoading === true) {
        setStep("loading")
      } else if (isLoading === false) {
        setTimeout(() => {
          setStep("joyride")
        }, 100)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, props, isLearningRoute, spnyImpactCourseTour, isCourseRoute])

  return { onComplete }
}
